import { DateRange }           from 'rewire-common';
import { ICell }               from 'rewire-grid';
import {
  IBatchTimecard,
  IBatchEmployeeTimecardResult
}                              from '../DataTypes';
import DataQueries             from '../graphql/Queries';
import PagingModel             from '../settings/PagingModel';
import TimecardSummaryBase     from '../timecard/TimecardSummaryBase';
import {
  payRouteManager,
  batchSummaryRouteManager
}                              from '../main-navigation/RouteManager';

class BatchTimecardSummaryModel extends TimecardSummaryBase {
  selectedBatch?: IBatchTimecard;

  constructor() {
    super();
    this.state.pagingModel = new PagingModel(this._load);
  }

  protected createEmployeeLink(cell: ICell) {
    if (!this.selectedBatch) return '';
    return payRouteManager.createLinkFor({ effective: this.selectedBatch.effective, selectedBatchId: this.selectedBatch.id, selectedEmployeeId: cell.row.data.id });
  }

  _load = async (): Promise<{ cursor?: string, totalCount: number }> => {
    if (!this.selectedBatch) return { cursor: '', totalCount: 0 };
    if (this.pagingModel.currentPage === undefined) {
      this.resetGrandTotals();
    }

    try {
      const effective: DateRange                  = this.selectedBatch.effective!;
      const filters                               = { batchIds: [this.selectedBatch.id] };
      const { sorts }                             = batchSummaryRouteManager;
      const results: IBatchEmployeeTimecardResult = await DataQueries.getEmployeeTimecardSummaries(effective, filters, undefined, sorts, this.pagingModel.itemsPerPage, this.pagingModel.currentPage);
      this.searchResultsMessage                   = super.hasResults(results) ? '' : 'No results found that match the filter criteria';

      super.updateGrandTotals(results);
      if (super.shouldDisplayGrandTotals(results, this.pagingModel.itemsPerPage, this.pagingModel.page)) {
        const columns = results.columns;
        this.state.grandTotals.reasons.map(r => r.name).forEach(r => {
          if (!columns.includes(r)) {
            columns.push(r);
          }
        });
        this.updateGridColumns(columns);
      } else {
        this.updateGridColumns(results.columns);
      }
      const rows = super.createRows(results, this.grid.columns);
      this.grid.set(rows);
      return results.results.length
              ? { cursor: results.cursor, totalCount: results.totalCount }
              : { cursor: '', totalCount: 0 };
    }
    catch (ex) {
      this.grid.set([]);
      this.searchResultsMessage = 'Error retrieving results';
      return { cursor: '', totalCount: 0 };
    }
  };

  loadBatch = (batch?: IBatchTimecard) => {
    this.selectedBatch = batch;
    this.resetGrandTotals();
    this.pagingModel.load();
  };

  get isLoading(): boolean {
    return super.isLoading || batchSummaryRouteManager.isLoading;
  }
}

const batchTimecardSummaryModel = new BatchTimecardSummaryModel();
export default batchTimecardSummaryModel;
